export default __webpack_public_path__ + "static/media/logo.ad1e797e.png";